import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { buscarDadosViagem } from '../servicos/listagemServico';
import { atualizarStatusPiloto, atualizarStatusViagemPeloPiloto } from '../servicos/cadastroServico';
import { useNavigate } from 'react-router-dom';
import LoadingIndicator from '../components/LoadingIndicator'

function MapaIndoAteCliente() {
  const [dadosCliente, setDadosCliente] = useState(null);
  const navigate = useNavigate();
  const [loadingIndicator, setLoadingIndicator] = useState(true);

  useEffect(() => {
    let mounted = true;

    const buscarDados = () => {
      // setLoadingIndicator(true);
      try {
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

        if (!dadosCookies || !dadosCookies.dadosPiloto?.objViagem) {
          if (mounted) {
            setLoadingIndicator(false);
            navigate('/pagina-piloto-mototaxi');
          }
          return;
        }

        const objViagem = dadosCookies.dadosPiloto.objViagem;
        const objUser = dadosCookies.dadosPiloto.objUser;

        if (mounted) {
          setDadosCliente({
            nome: objUser?.name || 'Cliente',
            endereco_origem: objViagem?.descricao_endereco_origem || 'Endereço não informado',
            endereco_destino: objViagem?.descricao_endereco_destino || 'Endereço não informado',
            celular: objViagem?.objInternautaCliente?.numero_celular_com_ddd || null
          });
          setLoadingIndicator(false);
        }
      } catch (err) {
        console.error('Erro ao buscar dados do cliente:', err);
        if (mounted) {
          setLoadingIndicator(false);
          navigate('/pagina-piloto-mototaxi');
        }
      }
    };

    buscarDados();

    // 🚀 executa logo na entrada também
    handleBuscarDadosViagem().catch(err => {
      console.error('Erro inicial no polling:', err);
    });

    const interval = setInterval(() => {
      // para polling em background, NÃO precisamos mostrar spinner toda vez;
      // apenas atualizar cookies / estado silenciosamente
      handleBuscarDadosViagem().catch(err => {
        console.error('Erro no polling:', err);
      });
    }, 10000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [navigate]);



  const atualizarLocalizacaoPiloto = () => {
    console.log('Entrou em atualizarLocalizacaoPiloto...');
    
    if (!navigator.geolocation) {
      console.warn('Geolocalização não suportada pelo navegador.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        console.log('📍 Localização atual do piloto: ', latitude, longitude);

        // Atualiza cookies
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : {};
        const novosDadosCookies = {
          ...dadosCookies,
          dadosPiloto: {
            ...dadosCookies.dadosPiloto,
            latitude,
            longitude,
            // mantém objViagem se existir
            objViagem: dadosCookies.dadosPiloto?.objViagem || null,
          },
        };
        Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

        console.log('🚀 Cookies atualizados com a localização do navegador');
      },
      (error) => {
        console.error('Erro ao obter geolocalização: ', error);
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 5000 }
    );
  };

  useEffect(() => {
    const intervalGeo = setInterval(() => {
      atualizarLocalizacaoPiloto();
    }, 15000); // a cada 10s

    return () => clearInterval(intervalGeo);
  }, []);


  // handler do polling (sempre retorna sem lançar exceção)
  const handleBuscarDadosViagem = async () => {
    // Nota: não ligamos o loadingIndicator aqui para não piscar a UI a cada 5s.
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

    if (!dadosCookies) {
      console.warn("Dados do cliente não encontrados nos cookies!");
      return;
    }

    console.log('***========!!!=======***');
    console.log('*** Entrou em handleBuscarDadosViagem ***');

    console.log('dadosCookies: ');
    console.log(dadosCookies);

    console.log('Latitude do piloto: ');
    console.log(dadosCookies.dadosPiloto.latitude);
    console.log('Longitude do piloto: ');
    console.log(dadosCookies.dadosPiloto.longitude);

    console.log('Latitude do cliente: ');
    console.log(dadosCookies.dadosPiloto.objViagem.latitude_internauta_cliente);
    console.log('Longitude do cliente: ');
    console.log(dadosCookies.dadosPiloto.objViagem.longitude_internauta_cliente);

    try {
      const response = await buscarDadosViagem(dadosCookies);

      const novosDadosCookies = {
        ...dadosCookies,
        dadosPiloto: {
          ...dadosCookies.dadosPiloto,
          objViagem: response.objViagem,
        }
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

      if (response?.objViagem?.nome_status === 'VIAGEM CANCELADA PELO CLIENTE') {
        alert('Sua viagem foi cancelada pelo cliente.');
        navigate('/pagina-piloto-mototaxi');
      } else if (response?.objViagem?.nome_status === 'VIAGEM INDO PARA O DESTINO FINAL') {
        navigate(`/mapa-levando-cliente-ao-destino`);
      } else {
        // opcional: atualizar dadosCliente se quiser refletir mudanças
        // por exemplo:
        // setDadosCliente(prev => ({ ...prev, ...algumaAtualizacao }));
      }
    } catch (e) {
      console.error('Erro ao buscar os dados da viagem:', e);
    }
  };

  const handleInformarQueChegouNoCliente = async () => {
    setLoadingIndicator(true);
    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
      if (!dadosCookies) {
        setLoadingIndicator(false);
        return;
      }

      const dadosCookiesAtualizados = JSON.parse(Cookies.get().dadosCookies);
      const respostaViagem = await atualizarStatusViagemPeloPiloto(
        dadosCookiesAtualizados,
        'VIAGEM INDO PARA O DESTINO FINAL'
      );

      const novoObjetoViagem = respostaViagem.objViagemAlterarStatus;
      const novosDadosCookies2 = {
        ...dadosCookiesAtualizados,
        dadosPiloto: {
          ...dadosCookiesAtualizados.dadosPiloto,
          objViagem: novoObjetoViagem
        }
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies2), { expires: 60 });
      navigate(`/mapa-levando-cliente-ao-destino`);
    } catch (e) {
      console.error(e);
    } finally {
      // setLoadingIndicator(false);
    }
  };

  const cancelarViagem = async () => {
    setLoadingIndicator(true);
    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
      if (!dadosCookies) {
        alert('Não foi possível localizar os dados do piloto.');
        setLoadingIndicator(false);
        return;
      }

      await atualizarStatusPiloto(dadosCookies, 'indisponivel');

      const cookiesAtualizados = Cookies.get();
      const dadosCookiesAtualizados = cookiesAtualizados.dadosCookies 
        ? JSON.parse(cookiesAtualizados.dadosCookies) 
        : null;

      if (!dadosCookiesAtualizados) {
        alert('Não foi possível atualizar os dados do piloto.');
        setLoadingIndicator(false);
        return;
      }

      const respostaViagem = await atualizarStatusViagemPeloPiloto(
        dadosCookies,
        'VIAGEM CANCELADA PELO PILOTO'
      );

      const novoObjetoViagem = respostaViagem?.objViagemAlterarStatus || null;
      if (!novoObjetoViagem) {
        alert('Não foi possível atualizar a viagem.');
        setLoadingIndicator(false);
        return;
      }

      const novosDadosCookies2 = {
        ...dadosCookiesAtualizados,
        dadosPiloto: {
          ...dadosCookiesAtualizados.dadosPiloto,
          objViagem: novoObjetoViagem
        }
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies2), { expires: 60 });
      navigate(`/pagina-piloto-mototaxi`);
    } catch (e) {
      console.error('Erro ao cancelar a viagem:', e);
      alert('Não foi possível recusar a solicitação.');
    } finally {
      // setLoadingIndicator(false);
    }
  };

  // 🔹 Abrir rotas (1 clique, app padrão do sistema) com coordenadas
  const openRotas = () => {
    console.log('Entrou em openRotas....');

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      if (!dadosCookies?.dadosPiloto?.objViagem) {
        alert('Não foi possível carregar as coordenadas.');
        return;
      }

      // Origem: piloto
      const latOrigem = dadosCookies.dadosPiloto.objViagem.latitude_piloto;
      const lngOrigem = dadosCookies.dadosPiloto.objViagem.longitude_piloto;

      console.log('dadosCookies.dadosPiloto.objViagem: ');
      console.log(dadosCookies.dadosPiloto.objViagem);

      console.log('latitude piloto: ');
      console.log(latOrigem);

      console.log('longitude piloto: ');
      console.log(lngOrigem);

      // Destino: cliente
      const latDestino = dadosCookies.dadosPiloto.objViagem.latitude_internauta_cliente;
      const lngDestino = dadosCookies.dadosPiloto.objViagem.longitude_internauta_cliente;

      console.log('latitude cliente: ');
      console.log(latDestino);

      console.log('longitude cliente: ');
      console.log(lngDestino);



      if (!latOrigem || !lngOrigem || !latDestino || !lngDestino) {
        alert('Coordenadas de origem/destino não disponíveis.');
        return;
      }

      const ua = navigator.userAgent || navigator.vendor || window.opera;

      // iOS → Apple Maps
      if (/iPad|iPhone|iPod/.test(ua)) {
        window.location.href = `http://maps.apple.com/?saddr=${latOrigem},${lngOrigem}&daddr=${latDestino},${lngDestino}&dirflg=d`;
        return;
      }

      // Android → esquema geo: aciona app padrão de mapas (Maps, Waze etc.)
      if (/Android/i.test(ua)) {
        const geoUrl = `geo:${latDestino},${lngDestino}?q=${latDestino},${lngDestino}(Cliente)`;
        const fallback = setTimeout(() => {
          window.location.href = `https://www.google.com/maps/dir/?api=1&origin=${latOrigem},${lngOrigem}&destination=${latDestino},${lngDestino}&travelmode=driving`;
        }, 1200);
        window.location.href = geoUrl;
        window.addEventListener('pagehide', () => clearTimeout(fallback), { once: true });
        window.addEventListener('blur', () => clearTimeout(fallback), { once: true });
        return;
      }

      // Desktop/Outros → Google Maps Web
      window.open(
        `https://www.google.com/maps/dir/?api=1&origin=${latOrigem},${lngOrigem}&destination=${latDestino},${lngDestino}&travelmode=driving`,
        '_blank',
        'noopener,noreferrer'
      );
    } catch (err) {
      console.error('Erro ao abrir rotas:', err);
      alert('Erro ao abrir o mapa.');
    }
  };


  // Se ainda estiver carregando inicial, mostra spinner
  if (loadingIndicator) {
    return <LoadingIndicator fullscreen message="Aguarde..." />;
  }

  // Se não houver dados do cliente (após carregar), mostra uma mensagem alternativa
  if (!dadosCliente) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 px-3">
        <div className="text-center">
          <p className="fw-bold fs-6">Dados do cliente não disponíveis.</p>
        </div>
      </div>
    );
  }

  // Acesso seguro ao celular:
  const celular = dadosCliente?.celular ? dadosCliente.celular.replace(/\D/g, '') : null;
  const linkWhatsApp = celular ? `https://wa.me/55${celular}` : null;

  return (
    <div className="container-fluid px-3 mt-4">
      <h4 className="text-center mb-3 text-primary fw-bold">
        <i className="bi bi-person me-2"></i>
        Cliente aguardando!
      </h4>

      <div className="card shadow-sm border-0 rounded-4 p-3 mb-3">
        <h5 className="fw-bold text-dark mb-2 text-truncate">{dadosCliente.nome}</h5>
        <hr className="my-2" />
        <p className="mb-1 small">
          <strong>📍 Endereço do Cliente: </strong> {dadosCliente.endereco_origem}
        </p>
        <hr className="my-2" />

        {linkWhatsApp ? (
          <p className="mb-1 small">
            <strong>📞 Telefone: </strong> {dadosCliente.celular}
            <br />
            <a
              href={linkWhatsApp}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-1 d-inline-flex align-items-center text-success fw-bold small"
              style={{ gap: '6px', textDecoration: 'none' }}
            >
              <i className="fab fa-whatsapp" style={{ fontSize: '18px' }}></i>
              Conversar no WhatsApp
            </a>
          </p>
        ) : (
          <p className="small"><strong>📞 Telefone:</strong> Não informado</p>
        )}
      </div>

      {/* 🔹 Botão Rotas (1 clique) */}
      <div className="d-grid gap-2 mb-3">
        <button type="button" className="btn btn-primary btn-lg w-100" onClick={openRotas}>
          <i className="bi bi-geo-alt me-2"></i> Rotas até o Cliente
        </button>
      </div>

      <div className="d-grid gap-2 d-md-flex justify-content-md-between mt-3">
        <button className="btn btn-danger btn-lg w-100 w-md-auto" onClick={cancelarViagem}>
          <i className="bi bi-x-circle me-2"></i> Cancelar Viagem
        </button>

        <button className="btn btn-success btn-lg w-100 w-md-auto mt-2 mt-md-0" onClick={handleInformarQueChegouNoCliente}>
          <i className="bi bi-check-circle me-2"></i> Cheguei no Cliente
        </button>
      </div>
    </div>
  );
}

export default MapaIndoAteCliente;
